import {Component, Inject, OnInit, VERSION, ViewChild} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {FacilityInventoryProduct} from "../../../../../model/FacilityInventoryProduct";
import {FacilityInventoryProductService} from "../../../../service-data/facility-inventory-product.service";
import {Organization} from "../../../../../model/Organization";
import {ProductService} from "../../../../service-data/product.service";
import {Order} from "../../../../../model/Order";
import {OrderDeliverTo} from "../../../../../model/OrderDeliverTo";
import {OrderItem} from "../../../../../model/OrderItem";
import {OrderDeliverToService} from "../../../../service-data/order-deliver-to.service";
import {OrderService} from "../../../../service-data/order.service";
import {FacilityService} from "../../../../service-data/facility.service";
import {ServerErrorToastService} from "../../../../service-ui/server-error-toast.service";
import {LanguagePipe} from "../../../../pipe/language.pipe";

@Component({
  selector: 'app-place-replenishment-order',
  templateUrl: './place-replenishment-order-component.html',
  styleUrls: ['./place-replenishment-order-component.css']
})
export class PlaceReplenishmentOrderComponent implements OnInit {
  public products: number[]; // Product[];
  public organizations: Organization[];
  public facilityInventoryProduct: FacilityInventoryProduct;
  public breakpoint: number; // Breakpoint observer code
  public quantity: number = 0;
  public batch: string;
  // public facilityId: number;
  public product_ID: number = 0;
  /** The FacilityInventoryProduct's primary product_ID — highlighted
   *  in the dropdown and pre-selected on open. Other entries from
   *  `productIds` are still available but shown as secondary. */
  public primaryProductId: number = 0;
  public formGroup: FormGroup;
  wasFormChanged = false;

  constructor(private formBuilder: FormBuilder, public dialog: MatDialog, public facilityService: FacilityService, public orderService: OrderService, public orderDeliverToService: OrderDeliverToService, public productService: ProductService, public facilityInventoryProductService: FacilityInventoryProductService, private serverErrorToastService: ServerErrorToastService, @Inject(MAT_DIALOG_DATA) data, private dialogRef: MatDialogRef<PlaceReplenishmentOrderComponent>) {
    this.facilityInventoryProduct = data.facilityInventoryProduct;
    this.primaryProductId = Number(this.facilityInventoryProduct.product_ID) || 0;
    this.products =  [];
    this.facilityInventoryProduct.productIds.split(',').forEach( product_ID => {
      const id = Number(product_ID);
      if ( !isNaN(id) && id > 0 ) {
        this.products.push(id);
      }
    });
    // Make sure the primary product_ID is in the list (it usually is,
    // but legacy rows occasionally have a productIds string that omits
    // it) and sort it to the top so it's the favored choice.
    if ( this.primaryProductId && this.products.indexOf(this.primaryProductId) === -1 ) {
      this.products.unshift(this.primaryProductId);
    } else if ( this.primaryProductId ) {
      this.products = [
        this.primaryProductId,
        ...this.products.filter(id => id !== this.primaryProductId)
      ];
    }
    // Pre-select the primary product so the operator can confirm
    // without having to open the dropdown.
    this.product_ID = this.primaryProductId;
    this.quantity = Math.max(this.facilityInventoryProduct.reorderQuantity, Math.ceil((this.facilityInventoryProduct.reorderQuantity + this.facilityInventoryProduct.quantityCommited - this.facilityInventoryProduct.quantityOnOrder - this.facilityInventoryProduct.quantityOnHand) / 4 ) * 4);
  }

  public ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      // facilityId: [this.facilityId, [Validators.required]],
      quantity: [this.quantity, [Validators.required]],
      batch: [this.batch, [Validators.required]],
      product_ID: [this.product_ID, [Validators.required]]
    });

    this.breakpoint = window.innerWidth <= 600 ? 1 : 2; // Breakpoint observer code
  }

  /**
   * Look up a Product's title (if the local cache has it) for display
   * in the dropdown. Returns an empty string when unknown.
   */
  public getProductTitle(productId: number): string {
    const product = this.productService.getLocalItem(productId);
    return product ? (product.title || '') : '';
  }

  public onSave(): void {
    this.facilityService.getItem(Number(this.facilityInventoryProduct.printnode_ID)).subscribe(facility => {
      const orderx = new Order(undefined);
      if (this.facilityInventoryProduct.product) {
        orderx.org_ID = this.facilityInventoryProduct.product.org_ID;
        const customerOrderIdDate = new Date();
        orderx.customerorderid = 'Replenishment-' + (customerOrderIdDate.getMonth() + 1) + '.' + (customerOrderIdDate.getDate() + 1) + '.' + customerOrderIdDate.getFullYear() + '.' + Math.floor(Math.random() * 1000); // this.orderStrategyFormGroup.controls.firstPartOfOrderId.value; // this.firstPartOfOrderId; // Add the current date and/or the org_id and or the umbrella to the id?
        orderx.inventoryType = 'REPLENISH_INVENTORY';
        orderx.replenishmentFacility_ID = this.facilityInventoryProduct.printnode_ID;
        this.orderService.addOrder(orderx).subscribe(order => {
          if (order && order.ID ) {
            const orderDeliverTo = new OrderDeliverTo(undefined);
            orderDeliverTo.inventoryType = order.inventoryType;
            orderDeliverTo.order_ID = order.ID;

            orderDeliverTo.title = '';
            orderDeliverTo.firstname = this.facilityInventoryProduct.title;
            orderDeliverTo.lastname = this.formGroup.controls.batch.value;
            // orderDeliverTo.company = this.facility;
            orderDeliverTo.address1 = facility.toAddress1;
            orderDeliverTo.address2 = facility.toAddress2;
            orderDeliverTo.address3 = this.facilityInventoryProduct.location + ' ' + this.facilityInventoryProduct.shelf;
            orderDeliverTo.city = facility.toCity;
            orderDeliverTo.state = facility.toState;
            orderDeliverTo.postalcode = facility.toPostalCode;
            orderDeliverTo.country = facility.toCountry;
            orderDeliverTo.carrier = 'INPLANT';
            orderDeliverTo.servicelevel = 'PICKUP';
            // orderDeliverTo.requestedPrintNodeName = '' + this.facilityId;
            orderDeliverTo.replenishmentFacility_ID = this.facilityInventoryProduct.printnode_ID;
            const orderItem = new OrderItem( undefined );
            orderItem.product_ID = this.formGroup.controls.product_ID.value; //  facilityInventoryProduct.product_ID;
            orderItem.quantity = this.formGroup.controls.quantity.value;
            orderDeliverTo.orderItems.push(orderItem);
            // PF-13. The dialog closes synchronously below, before this
            // request has even been sent, so there is no dialog left to show
            // an error in -- which is precisely why the old `console.log` on
            // failure was invisible. The snack-bar is an overlay and survives
            // the close, so the operator finds out either way.
            this.orderDeliverToService.addOrderDeliverTo(orderDeliverTo).subscribe(
              createdOrderDeliverTo => {
                console.log(`Saved an OrderDeliverTo ${createdOrderDeliverTo.ID} for Order ${order.ID}`);
                this.serverErrorToastService.reportSuccess(
                  LanguagePipe.get('Replenishment order placed.'));
              },
              error => this.serverErrorToastService.reportError('addOrderDeliverTo (replenishment)', error,
                LanguagePipe.get('The replenishment order could not be placed.'))
            );
          } else {
            this.serverErrorToastService.reportMessage(
              LanguagePipe.get('The replenishment order could not be placed.'));
          }
        });
      }
    });
    this.markAsDirty(this.formGroup);
    this.dialogRef.close();
  }

  // tslint:disable-next-line:no-any
  public onResize(event: any): void {
    this.breakpoint = event.target.innerWidth <= 600 ? 1 : 2;
  }

  private markAsDirty(group: FormGroup): void {
    group.markAsDirty();
    // tslint:disable-next-line:forin
    for (const i in group.controls) {
      group.controls[i].markAsDirty();
    }
  }

  formChanged() {
    this.wasFormChanged = true;
  }

}
